/** 
 *   订货管理 api
 */
import { get, post, put, del } from '@/untils/axios.js'


/*
 *   规格
 */

// 规格 列表
export const specs     = params      => get('specs', params)
// 规格 添加
export const specs_add = params      => post('specs', params)
// 规格 更新
export const specs_put = (id,params) => put(`specs/${id}`, params)
// 规格 删除
export const specs_del = id          => del(`specs/${id}`)
// 规格 查询 无分页
export const specs_get = params      => get(`specs/getspecs`,params)


/*
 *   自营订货
 */

// 采购单手动上传 添加
export const purchase         = params => post('purchase', params)
// 采购筛选 列表
export const purchase_get     = params => get('purchase', params)
// 采购筛选 删除
export const purchase_del     = id     => del(`purchase/${id}`)
// 采购筛选 添加到订货单
export const purchase_order   = params => post(`purchase/addorder`,params)
// audit ： 0 采购下单列表 1 进货单审核列表  2 查看进货单列表
export const purchase_list    = (id,params)  => get(`purchase/orderbuy/${id}`,params)
// 采购下单  添加进货价格 进货数量
export const purchase_edit    = (id,params)  => put(`purchase/editproinfo/${id}`,params)
// 采购下单  取消下单
export const purchase_cancel  = id     => del(`purchase/cancelorder/${id}`)
// 采购下单  确认下单
export const purchase_confirm = id     => put(`purchase/confirmorder/${id}`)
// 进货单审核  确认下单
export const purchase_buy     = params => put(`purchase/confirmorderbuy`,params)
// 查看进货单 获取交易记录列表
export const ordertransaction = params => get(`ordertransaction/list`,params)

// 查看进货单 上传交易记录
export const uploads = params => post(`ordertransaction/uploads`,params)
// 查看进货单 删除交易记录
export const img_del = params => post(`ordertransaction/delpic`,params)
// 修改进货价
export const update_orderbuy = (id,params) => put(`purchase/update-orderbuy/${id}`,params)
// 查看进货单 上传交易记录
export const purchase_addtransaction = params => post(`/purchase/addtransaction`,params)

// 下架
export const goods_offshelf = params => post(`purchase/goods/offshelf`,params)

// 供应商显示
export const get_supplier_info = params => get(`supplier/info`,params);

// 供应商添加
export const post_supplier_info = params => post(`supplier/info`,params);
